import { isEmptyObject } from "@/components/utils"
import { type LocationGroup, type LocationMethod, type PriceInfo } from "../../types"
import { type PriceGroupInfo, type PriceSpecLimitation } from "./types"

/**
 * 合并price分组
 * 如price A有限制，Price B无限制，那就把PriceA合并到Price B里。
 * @param priceGroup
 * @param allSpecLimitaion
 * @param allImprintMethodNames
 * @returns
 */
export function mergePriceGroup (
  priceGroup: PriceGroupInfo[],
  allSpecLimitaion: Record<string, string[]>,
  allImprintMethodNames: string[]
): PriceGroupInfo[] {
  // 开始合并分组
  for (let i = priceGroup.length - 1; i >= 0; i--) {
    const thisItem = priceGroup[i]

    const isSubset = priceGroup.some(function (thatItem: any, j: number) {
      if (i === j) return false

      // 判断spec是否为子集
      let isSpecSubset = true
      const thisSpecLimitaion = isEmptyObject(thisItem.specLimitation)
        ? allSpecLimitaion
        : thisItem.specLimitation
      const thatSpecLimitaion = isEmptyObject(thatItem.specLimitation)
        ? allSpecLimitaion
        : thatItem.specLimitation

      for (const name in thisSpecLimitaion) {
        if (thatSpecLimitaion[name]) {
          // 判断所有spec 是否都在里面
          if (
            thisSpecLimitaion[name].every(function (val: any) {
              return thatSpecLimitaion[name].includes(val)
            }) === false
          ) {
            isSpecSubset = false
            break
          }
        }
      }
      if (isSpecSubset) {
        // 判断imprint是否为子集
        const thisImprintMethodLimitaion =
          thisItem.imprintMethodLimitation.length > 0
            ? thisItem.imprintMethodLimitation
            : allImprintMethodNames
        const thatImprintMethodLimitaion =
          thatItem.imprintMethodLimitation.length > 0
            ? thatItem.imprintMethodLimitation
            : allImprintMethodNames

        if (
          thisImprintMethodLimitaion.every(function (m: any) {
            return thatImprintMethodLimitaion.includes(m)
          }) === false
        ) {
          return false
        }
      }

      if (isSpecSubset) {
        // 如果是子集，取最小的minQty
        thatItem.minQty = Math.min(thatItem.minQty, thisItem.minQty)
        thatItem.priceList = thatItem.priceList.concat(thisItem.priceList)
      }
      return isSpecSubset
    })

    // 如果是子集，那就删除当前的
    if (isSubset) {
      priceGroup.splice(i, 1)
    }
  }

  return priceGroup
}

/**
 * 判断用户点击的spec 是否在当前group li，
 * @param priceList
 * @param specName
 * @param specValue
 * @returns
 */
 export function isCurrentGroup (
  priceList: PriceInfo[],
  specName: string,
  specValue: string
): boolean {
  // 先按照spec limitation分组

  return priceList.some((price) => {
    if (isEmptyObject(price.SpecLimitation) === false) {
      for (const key in price.SpecLimitation) {
        const specValues = price.SpecLimitation[key]
        // 如果当前点击的spec，判断所选的值是否在price里
        // 如果不在price里,那就是要切换到blank或imprint
        if (key === specName) {
          if (specValues.includes(specValue)) {
            return true
          }
        }
      }
      return false
    } else {
      return true
    }
  })
}

export function mapSpecLimitation (
  val: Record<string, string[]>
): PriceSpecLimitation[] {
  const arr: PriceSpecLimitation[] = []
  for (const key in val) {
    arr.push({
      name: key,
      values: val[key]
    })
  }
  return arr
}

/**
 * 判断location是否相同
 * @param locationGroupList
 * @param priceGroup
 * @returns
 */
export function allLocationSame (
  locationGroupList: LocationGroup[],
  priceGroup: PriceGroupInfo[]
): boolean {
  let showLocation = true
  const allLocationMap = priceGroup.map((item) => {
    if (item.imprintMethodLimitation.length > 0) {
      const arr: LocationMethod[] = []
      locationGroupList.forEach((f: LocationGroup) => {
        arr.push(
          ...f.Methods.filter((m: LocationMethod) =>
            item.imprintMethodLimitation.includes(m.Method)
          )
        )
      })
      const s = [...new Set(arr.map((f) => f.Location))]
      s.sort()
      return s.join(',')
    }
    return ''
  })
  let str: string | null = null
  allLocationMap.forEach((f) => {
    if (str === null) {
      str = f
    }
    if (str !== f) {
      showLocation = false
    }
  })
  return showLocation
}

